import React from 'react';
import './Spinner.css';

const Spinner = (props) => {
  let nameClass = !!props.nameClass ? props.nameClass : 'lds-default';

  return (
    <div className={nameClass}>
      <div className='pont' id='pontOne'></div>
      <div className='pont' id='pontTwo'></div>
      <div className='pont' id='pontThree'></div>
      <div className='pont' id='pontFour'></div>
      <div className='pont' id='pontFive'></div>
      <div className='pont' id='pontSix'></div>
      <div className='pont' id='pontSeven'></div>
      <div className='pont' id='pontEight'></div>
      <div className='pont' id='pontNine'></div>
      <div className='pont' id='pontTen'></div>
      <div className='pont' id='pontEleven'></div>
      <div className='pont' id='pontTwelve'></div>
    </div>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js